import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function ActionAreaCard(params) {
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardActionArea component={RouterLink} to={params.link}>
        <CardMedia
          component="img"
          height="140"
          image="/images/swcrop1.png"
          alt="green iguana"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {params.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {params.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}